export const generateUrl = (phone, message) => {
  const to = phone;
  const addMessage = `/?text=${message}`;
  const base = `https://wa.me/${to}`;
  return message ? base + addMessage : base;
};
